import * as React from 'react';
import { LineChart } from '@mui/x-charts/LineChart';
import { ChartsReferenceLine } from '@mui/x-charts/ChartsReferenceLine';
import api from "../utils/api";
import {useEffect} from "react";

export default function BasicLineChart(props: any) {
  const [normalWeight, setNormalWeight] = React.useState(0);  // BMI 기준 정상 체중의 평균
  
  useEffect(() => {
    getProfileData();
  }, []);
  
  function getProfileData(){
    api.get('permission/getProfile').then((res:any) => {
      const memberHeight = res.data.height;
      const minNormalWeight = 18.5 * ((memberHeight / 100) * (memberHeight / 100));
      const maxNormalWeight = 23 * ((memberHeight / 100) * (memberHeight / 100));
      
      setNormalWeight((minNormalWeight + maxNormalWeight) / 2);
    }).catch(function (error:any) {
      console.log(error)
    });
  }

  // 정상 기준선이 y축 자동 범위(측정값 최소~최대) 밖으로 벗어나면 선이 보이지 않으므로
  // 기준선을 쓰는 경우에만 기준선이 들어가도록 y축 범위를 넓혀준다.
  function getYAxis() {
    // 키 정보가 없으면(NaN, 0) 기준선을 계산할 수 없으므로 자동 스케일 유지
    if (!props.isReferenceLine || !(normalWeight > 0)) {
      return undefined;
    }

    const values: number[] = [];
    for (let item of props.series || []) {
      for (let value of item.data || []) {
        if (typeof value === 'number' && value > 0) {
          values.push(value);
        }
      }
    }
    if (values.length === 0) {
      return undefined;
    }

    values.push(normalWeight);
    const min = Math.min(...values);
    const max = Math.max(...values);
    const padding = Math.max((max - min) * 0.1, 1);

    return [{ min: Math.floor(min - padding), max: Math.ceil(max + padding) }];
  }

  return (

    <LineChart
      xAxis={props.xAxis}
      yAxis={getYAxis()}
      series={props.series}
      colors={['#279700']}
      height={300}
      margin={{ left: 40, right: 20 }}
      sx={{
        '& .MuiChartsReferenceLine-label' : {fontSize:'14px !important', fill:'#0093ff'}
        }}
      grid={{ vertical: true, horizontal: true }}

    >
      {props.isReferenceLine ? <ChartsReferenceLine y={normalWeight} label="정상" lineStyle={{ stroke: '#0093ff',strokeWidth: 2, }}  labelAlign={'end'} /> : null}

    </LineChart>



  );
}


